import { brandConfigMap, getBrandConfig } from "@/brand";
import store from "@/store";
import { Brands } from "@/brand/brandConfig";

export function setBrandConfig() {
    const domain = window.origin;

    // Get brand config - simplified for single brand (MTN LeagueXI)
    let brandConfig = brandConfigMap.get(domain)
        ? brandConfigMap.get(domain)
        : brandConfigMap.get('default');

    store.commit('setBrandConfig', brandConfig);
    console.log('Brand config set:', brandConfig);

    const brandStyles = require(`../brand/${brandConfig.brand}/styles/index.js`).styles;
    const brandStyleSheet = document.createElement('style');

    let brandStyleInnerHTML = '';

    // Generate background color classes
    brandStyles.backgrounds.forEach((background) => {
        if (brandStyleInnerHTML === '') {
            brandStyleInnerHTML += `.${background.className} { background-color: ${background.colour} }`;
        } else {
            brandStyleInnerHTML += ` .${background.className} { background-color: ${background.colour} }`;
        }
    });

    // Generate text color classes
    brandStyles.text.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { color: ${textItem.colour} }`;
    });

    // Generate border classes
    brandStyles.borders.forEach((borderItem) => {
        brandStyleInnerHTML += ` .${borderItem.className} { border: 1.5px solid ${borderItem.colour} }`;
    });

    brandStyleSheet.innerHTML = brandStyleInnerHTML;
    document.body.appendChild(brandStyleSheet);
}
